// MIRRORS: panel/brand.ts — identical copy; edit both, or delete this line on both to declare a deliberate split.
/**
 * The product name, in one place. The name and the domain are about to change:
 * everything user-facing reads it from here (tr.ts, and index.html through
 * fillBrand at build time), so the rename is a one-line edit.
 */
export const APP_NAME = 'Çiftçi Borsası';
export const APP_TAGLINE = 'Güvenli Ticaret Ağı';

/** Fills the %APP_NAME% / %APP_TAGLINE% placeholders in index.html. */
export function fillBrand(html: string): string {
  return html.split('%APP_NAME%').join(APP_NAME).split('%APP_TAGLINE%').join(APP_TAGLINE);
}
